import { render, staticRenderFns } from "./pre_message_text.vue?vue&type=template&id=56a40b37&scoped=true"
import script from "./pre_message_text.vue?vue&type=script&lang=js"
export * from "./pre_message_text.vue?vue&type=script&lang=js"
import style0 from "./pre_message_text.vue?vue&type=style&index=0&id=56a40b37&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a40b37",
  null
  
)

export default component.exports